
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profiles/[slug]/discussions",
      function () {
        return require("private-next-pages/profiles/[slug]/discussions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profiles/[slug]/discussions"])
      });
    }
  